import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ApiProcesosService } from 'src/app/shared/services/api-procesos.service';
import { Proceso, Empresa } from 'src/app/classes/coordinador';
import { ApiEmpresasService } from '../../services/api-empresas.service';
import { ApiDocumentosService } from '../../services/api-documentos.service';
import { AppStorage } from '../../services/appStorage.service';
import { ExcelService } from '../../services/excel.service';

@Component({
  selector: 'app-modal-descarga-datos',
  templateUrl: './modal-descarga-datos.component.html',
  styleUrls: ['./modal-descarga-datos.component.css']
})
export class ModalDescargaDatosEmpresaComponent implements OnInit {
  // Loading
  loadingProcesos;
  loadingEmpresas;

  // Data
  procesos: Proceso[];
  empresas: Empresa[];
  meses = [];
  annos = [];
  noData = false;

  // Filtros Seleccionados
  proceso: Proceso;
  empresa: Empresa;
  mes;
  anno;

  filtroEmpresa;

  // Error
  error;

  // Meses para armar documento excel
  mesesTexto = [
    {
      nombre: 'Enero',
      sigla: 'Ene',
      numero: 1
    },
    {
      nombre: 'Febrero',
      sigla: 'Feb',
      numero: 2
    },
    {
      nombre: 'Marzo',
      sigla: 'Mar',
      numero: 3
    },
    {
      nombre: 'Abril',
      sigla: 'Abr',
      numero: 4
    },
    {
      nombre: 'Mayo',
      sigla: 'May',
      numero: 5
    },
    {
      nombre: 'Junio',
      sigla: 'Jun',
      numero: 6
    },
    {
      nombre: 'Julio',
      sigla: 'Jul',
      numero: 7
    },
    {
      nombre: 'Agosto',
      sigla: 'Ago',
      numero: 8
    },
    {
      nombre: 'Septiembre',
      sigla: 'Sep',
      numero: 9
    },
    {
      nombre: 'Octubre',
      sigla: 'Oct',
      numero: 10
    },
    {
      nombre: 'Noviembre',
      sigla: 'Nov',
      numero: 11
    },
    {
      nombre: 'Diciembre',
      sigla: 'Dic',
      numero: 12
    }
  ];

  constructor(
    public dialogRef: MatDialogRef<ModalDescargaDatosEmpresaComponent>,
    private apiProcesosService: ApiProcesosService,
    private apiEmpresasService: ApiEmpresasService,
    private apiDocumentosService: ApiDocumentosService,
    private appStorage: AppStorage,
    private excelService: ExcelService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.anno = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      1
    ).getFullYear();
    this.cargarAnnos();
    this.cargarMeses();
    this.cargarProcesos();
    this.cargarEmpresas();
  }

  getMesPalabra(mes: string) {
    return this.mesesTexto.filter(element => element.sigla === mes);
  }

  descargar() {
    this.noData = false;
    this.appStorage.loadingGeneral = true;
    this.apiDocumentosService
      .getAllDocumentosUsuarioEmpresaDescarga(this.anno, this.mes, this.proceso)
      .then((res: any) => {

        if (res) {
          const documentos = this.filtrarDocumentos(res);
          if (documentos.length === 0) {
            this.noData = true;
          } else {

            let documentostmp: any = {};
            const documentosFinales = [];

            documentos.forEach(element => {
              const nombreArchivoSegmentado = element.Nombre_archivo.split('_');
              const largo = nombreArchivoSegmentado.length;
              const siglaMes = nombreArchivoSegmentado[largo - 1].substr(4, 3);
              const mesPalabra = this.getMesPalabra(siglaMes);

              const filtros = {
                Proceso: this.proceso.sigla,
                Año: this.anno,
                Mes: mesPalabra[0].nombre
              };

              documentostmp = {...filtros, ...element };
              documentosFinales.push(documentostmp);
            });
            this.excelService.exportAsExcelFile(documentosFinales, 'Registro_Atrasos_' + this.proceso.sigla + this.anno);
          }
        } else {
          this.noData = true;
        }

        this.appStorage.loadingGeneral = false;
      })
      .catch(error => {
        this.appStorage.loadingGeneral = false;
      });
  }

  camposValidos() {
    return this.proceso && this.anno;
  }

  filtrarDocumentos(documentos: any[]) {
    let documentosFiltrados = documentos;

    if (this.empresa) {
      documentosFiltrados = documentos.filter(item => {
        return item.idEmpresa === this.empresa.idEmpresa;
      });
    }

    const resp = [];
    for (const doc of documentosFiltrados) {
      resp.push({
        Empresa: doc.nombre_fantasia,
        Version: doc.version,
        'Fecha_de_Carga':
          doc.diaSubida + '-' + doc.mesSubida + '-' + doc.anioSubida,
        'Dias de atraso': doc.diasAtraso,
        'Nombre_archivo': doc.nombreArchivo
      });
    }

    return resp;
  }

  cargarProcesos() {
    this.loadingProcesos = true;
    this.apiProcesosService
      .getProcesosActivos()
      .then((res: any) => {
        this.procesos = res;
        this.procesos.sort(function(a, b) {
          if (a.sigla < b.sigla) {
            return -1;
          }
          if (a.sigla > b.sigla) {
            return 1;
          }
          return 0;
        });
        this.loadingProcesos = false;
      })
      .catch(error => {
        this.loadingProcesos = false;
      });
  }

  cargarEmpresas() {
    this.loadingEmpresas = true;
    this.apiEmpresasService
      .getEmpresasUsuarioEmpresa()
      .then((res: any) => {
        this.empresas = res;
        this.empresas = this.empresas.filter(item => item.sigla !== null);
        this.empresas.sort(function(a, b) {
          if (a.sigla < b.sigla) {
            return -1;
          }
          if (a.sigla > b.sigla) {
            return 1;
          }
          return 0;
        });
        this.loadingEmpresas = false;
      })
      .catch(error => {
        this.error = true;
        this.loadingEmpresas = false;
        console.error(error);
      });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  ok() {
    this.dialogRef.close(true);
  }

  cargarAnnos() {
    const primerAnno = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + -1,
      1
    ).getFullYear();

    for (let i = primerAnno; i > primerAnno - 10 && i >= 2018; i--) {
      this.annos.push(i);
    }
  }
  volverACargar() {
    this.noData = false;
  }

  cargarMeses() {
    this.mes = undefined;

    this.meses = [
      {
        nombre: 'Enero',
        sigla: 'Ene',
        numero: 1,
        bloqueado: false
      },
      {
        nombre: 'Febrero',
        sigla: 'Feb',
        numero: 2,
        bloqueado: false
      },
      {
        nombre: 'Marzo',
        sigla: 'Mar',
        numero: 3,
        bloqueado: false
      },
      {
        nombre: 'Abril',
        sigla: 'Abr',
        numero: 4,
        bloqueado: false
      },
      {
        nombre: 'Mayo',
        sigla: 'May',
        numero: 5,
        bloqueado: false
      },
      {
        nombre: 'Junio',
        sigla: 'Jun',
        numero: 6,
        bloqueado: false
      },
      {
        nombre: 'Julio',
        sigla: 'Jul',
        numero: 7,
        bloqueado: false
      },
      {
        nombre: 'Agosto',
        sigla: 'Ago',
        numero: 8,
        bloqueado: false
      },
      {
        nombre: 'Septiembre',
        sigla: 'Sep',
        numero: 9,
        bloqueado: false
      },
      {
        nombre: 'Octubre',
        sigla: 'Oct',
        numero: 10,
        bloqueado: false
      },
      {
        nombre: 'Noviembre',
        sigla: 'Nov',
        numero: 11,
        bloqueado: false
      },
      {
        nombre: 'Diciembre',
        sigla: 'Dic',
        numero: 12,
        bloqueado: false
      }
    ];

    if (new Date().getFullYear() === this.anno) {
      const mesActual = new Date().getMonth() + 1;
      for (const mes of this.meses) {
        mes.bloqueado = mes.numero >= mesActual;
      }
    }
  }
}
